var ValueJS = ValueJS || {};

ValueJS.Shopify = ValueJS.Shopify || {};

ValueJS.Shopify.DesignMode = function() {

    var _initialized = false;

    var _init = function() {
        if (!_initialized) {
            if (typeof Shopify !== 'undefined') {
                if (Shopify.designMode) {
                    $(document).on('shopify:section:load', function(e) {
                        $.publish('domUpdate');
                    });
                }
            }
            _initialized = true;
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();}
    };

}();

$(function() {
    ValueJS.Shopify.DesignMode.init();
});
